import React from 'react';
import cn from 'classnames';
import Benefits from '../Benefits';
import Features from './Features';
import QuoteForm from './QuoteForm';
import titlePattern from '../assets/titlePattern.svg';

import styles from './getQuote.module.scss';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import baseStyles from '../tenant17g5Styles.module.scss';

const GetQuote = () => (
  <>
    <div className={ baseStyles.intro }>
      <div className={ styles.introContainer }>
        <h1 className={ cn(baseStyles.sectionTitle, baseStyles.title) }>
          Migrate to 17g5.com and Save Thousands
        </h1>
        <div className={ cn(baseStyles.sectionDescription, baseStyles.description) }>
          A great data room, at an industry leading price, with fanatical 24x7 support.<br />
          Backed by a <span>30-Day Free Trial</span> and a <span>Savings Guarantee</span> on migrations.
        </div>
        <div className={ baseStyles.titlePattern }>
          <img src={ titlePattern.src } />
        </div>
      </div>
    </div>
    <div className={ cn(styles.quoteFormWrp, cardStyles.cardContainer) }>
      <Features />
      <QuoteForm />
    </div>
    <div className={ styles.benefits }>
      <Benefits />
    </div>
  </>
);

export default GetQuote;
